export default __webpack_public_path__ + "static/media/add_photo.0cd52a25.png";